// extracted by mini-css-extract-plugin
export default {"container":"payment_container__C3saD","head3":"payment_head3__dp2w9"};